// TODO: Clean this up, this is just a direct copy from the old app
// TODO: Readd capability to attach query params from an object
// TODO: Deprecate this entire implementation when we stop using interact
import { withQuery, normalizeURL } from 'ufo'

export const normalizeProtocol = (url: string) => {
  if (!url) return ''
  if (url.startsWith('//')) return normalizeURL('https:' + url)
  return normalizeURL(url)
}
export function buildUrl(relativeUrl: string, query: Record<string, string>): string {
  // Assembles a full url for a relative url
  const path = relativeUrl.charAt(0) === '/' ? relativeUrl : `/${relativeUrl}`
  const port =
    window.location.port === '80' || window.location.port === '442'
      ? ''
      : ':' + window.location.port
  const protocol = location.protocol === 'https:' ? 'https://' : 'http://'
  // const query = queryObject ? '?' + queryString.stringify(queryObject) : ''
  return `${protocol}${window.location.hostname}${port}${withQuery(path, query)}`
}

export type ResultStates = 'ok' | 'aborted' | 'invoice' | 'postal'
// No name or other personal param: pixels record the thank-you URL (#2158). Who the donor is
// travels as the result-token cookie the form's server route sets.
export const resultUrl = ({
  state,
  sysId,
  transactionId = '',
  hc = '',
  partId = '',
  customerId = '',
  invoiceId = '',
  whId = '',
}: {
  state: ResultStates
  sysId: string
  transactionId?: string
  hc?: string
  partId?: string
  customerId?: string
  invoiceId?: string
  whId?: string
}) => {
  return buildUrl('/thank-you', {
    state,
    sysId,
    transactionId,
    hc,
    partId,
    customerId,
    invoiceId,
    whId,
  })
}

export const thirdBlockNavigate = (url: string | undefined) => {
  const redirectUrl = url || 'https://stod.djurensratt.se/manadsgivare'

  navigateTo(redirectUrl, { external: true })
}
